class productCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.container = this.querySelector(".flex_wrapper");
    this.slides = this.querySelectorAll(".featured__collection-product");
    this.nextBtn = this.querySelector(".scroll_carousel_next");
    this.prevBtn = this.querySelector(".scroll_carousel_prev");

    this.nextBtn.addEventListener("click", () => this.next());
    this.prevBtn.addEventListener("click", () => this.prev());

    this.container.addEventListener("scroll", () => this.disabledButton());

    this.disabledButton();
  }

  next() {
    const slide = this.slides[0];
    if (!slide) return;

    this.container.scrollBy({
      left: slide.offsetWidth,
      behavior: "smooth"
    });
  }

  prev() {
    const slide = this.slides[0];
    if (!slide) return;

    this.container.scrollBy({
      left: -slide.offsetWidth,
      behavior: "smooth"
    });
  }

  disabledButton() {
    const maxScroll =
      this.container.scrollWidth - this.container.clientWidth;
    this.prevBtn.disabled = this.container.scrollLeft <= 0;
    this.nextBtn.disabled = this.container.scrollLeft >= maxScroll - 1;
  }
}

if (!customElements.get("product-carousel")) {
  customElements.define("product-carousel", productCarousel);
}